import { render } from "./KubernetesScheduling.vue?vue&type=template&id=fd15c39e"
import script from "./KubernetesScheduling.vue?vue&type=script&lang=js"
export * from "./KubernetesScheduling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__